export default __webpack_public_path__ + "static/media/pag7.988e38db.jpg";